import { apiClient } from './axios'

export const uploadImage = async (formData) => {
  try {
    const response = await apiClient.post('api/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error uploading file:', error)
    throw error
  }
}


export const getCompetitionsForms = async () => {
  try {
    return (await apiClient.get(`api/competitions-forms`)).data
  } catch (err) {
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}

export const postCompetition = async (data) => {
  try {
    const response = await apiClient.post(`api/competition`, data)
    return response.data
  } catch (error) {
    console.error('Error creating competition:', error)
    return false
  }
}

export const putCompetition = async (data) => {
  try {
    const response = await apiClient.put(`api/competition/${data.id}`, data)
    return response.data
  } catch (error) {
    console.error('Error updating competition:', error)
    return false
  }
}

export const deleteCompetition = async (id) => {
  try {
    const response = await apiClient.delete(`api/competition/${id}`)
    return response.data
  } catch (error) {
    console.error('Error updating competition:', error)
    return false
  }
}

export const getFormByCompetitionId = async (id) => {
  try {
    const response = await apiClient.get(`api/form-descriptors/${id}`)
    return response.data
  } catch (error) {
    console.error('Error updating competition:', error)
    return false
  }
}

export const putFormDescriptor = async (form) => {
  try {
    const response = await apiClient.put(`api/form-descriptor`, {form})
    return response.data
  } catch (error) {
    console.error('Error updating competition:', error)
    return false
  }
}

export const postFormDescriptor = async (id, data) => {
  try {
    const response = await apiClient.post(`api/form-descriptor/${id}`, data)
    return response.data
  } catch (error) {
    console.error('Error updating competition:', error)
    return false
  }
}

export const deleteFormDescriptor = async (id) => {
  try {
    const response = await apiClient.delete(`api/form-descriptor/${id}`)
    return response.data
  } catch (error) {
    console.error('Error deleting form-descriptor:', error)
    return false
  }
}

export const publishCompetition = async (id) => {
  try {
    const response = await apiClient.post(`/api/competition-publish/${id}`)
    return response.data
  } catch (error) {
    console.error('Error publishing competition:', error)
    return false
  }
}

export const getExports = async () => {
  try {
    const response = await apiClient.get(`api/exports`)
    return response.data
  } catch (error) {
    console.error('Error getting exports:', error)
    return false
  }
}

export const makeExport = async (id) => {
  try {
    const response = await apiClient.get(`api/make-export/${id}`)
    return response.data
  } catch (error) {
    console.error('Error getting exports:', error)
    return false
  }
}

export const getAllAdmins = async () => {
  try {
    const response = await apiClient.get('api/admins');
    return response.data;
  } catch (error) {
    console.error('Error getting admins:', error);
    return false;
  }
};

export const deleteAdmin = async (email) => {
  try {
    const response = await apiClient.delete(`api/admins/${email}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting admin with email ${email}:`, error);
    return false;
  }
};

export const postAdmin = async (email) => {
  try {
    const response = await apiClient.post('api/admins', { email });
    return response.data;
  } catch (error) {
    console.error('Error adding admin:', error);
    return false;
  }
}

export const checkAdmin = async () => {
  try {
    return (await apiClient.get('api/check-admin')).data
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}


export const getAdminFormType = async (formName, section) => {
  try {
    return (await apiClient.get(`api/admin-form-type/${formName}/${section}`)).data
      .results[0]
  } catch (err) {
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}

export const createInstitution = async (data) => {
  try {
    const response = await apiClient.post('api/institutions', data)
    return response.data
  } catch (error) {
    console.error('Error creating institution:', error)
    return false
  }
}

export const getInstitutionById = async (id) => {
  try {
    const response = await apiClient.get(`api/institutions/${id}`)
    return response.data
  } catch (error) {
    console.error('Error fetching institution:', error)
    return false
  }
}

export const updateInstitution = async (data) => {
  try {
    const response = await apiClient.put(`api/institutions`, data)
    return response.data
  } catch (error) {
    console.error('Error updating institution:', error)
    return false
  }
}

export const deleteInstitution = async (id) => {
  try {
    const response = await apiClient.delete(`api/institutions/${id}`)
    return response.data
  } catch (error) {
    console.error('Error deleting institution:', error)
    return false
  }
}

export const getAllInstitutions = async () => {
  try {
    const response = await apiClient.get('api/institutions')
    return response.data
  } catch (error) {
    console.error('Error fetching institutions:', error)
    return false
  }
}

export const archiveCompetition = async (id) => {
  try {
    const response = await apiClient.post(`api/competition-archive/${id}`)
    return response.data
  } catch (error) {
    console.error('Error archiving competition:', error)
    return false
  }
}
